export default "/wp-content/themes/onnit/script/cart/dist/onnitIn30Override-00ca3c3d.png";